import { render } from "./PasswortTestBar.vue?vue&type=template&id=145d2768"
import script from "./PasswortTestBar.vue?vue&type=script&lang=js"
export * from "./PasswortTestBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__